// extracted and used mostly for e2e testing
export const formControlIdentifier = {
    location: (name: string) => `location-control-name-${name}`,
    reactSelect: (name: string) => `react-select-name-${name}`,
};
